export default __webpack_public_path__ + "static/media/foam2.f0c4b4ce.jpg";